/* eslint-disable indent */

/* eslint-disable import/no-extraneous-dependencies */
import HttpService from '@pingum/api-services/HttpService';
import AuthService from '@pingum/api-services/AuthService';
import axios from 'axios';
import { getTenantFromUrl } from '../../utils/urlHelper';

export default class BillableService {
  static getInvoices(barnUserIds, status, startDate, endDate, page, size, sort) {
    const http = axios.create({
      baseURL: `${typeof window !== 'undefined'
        ? env.REACT_APP_HORSE_API
        : ''}/invoices`,
      headers: {
        'content-type': 'application/json',
        'X-Tenant': getTenantFromUrl(),
        authorization: `Bearer ${AuthService.getToken()}`,
      },
    });
    return new Promise((resolve) => {
      http.get(encodeURI(`/?barnUserIds=${barnUserIds}&status=${status}&startDate=${startDate === null
        ? ''
        : startDate.toISOString()}&endDate=${endDate
          ? endDate.toISOString()
          : ''}&page=${page}&size=${size}${sort}`))
        .then((response) => {
          resolve(response);
        });
    });
  }

  static getInvoice(id, includeToken = true) {
    if (!id) {
      return Promise.reject(new Error('Missing Invoice ID'));
    }

    const http = axios.create({
      baseURL: `${typeof window !== 'undefined'
        ? env.REACT_APP_HORSE_API
        : ''}/invoices`,
      headers: {
        'content-type': 'application/json',
        'X-Tenant': getTenantFromUrl(),
        authorization: includeToken
          ? `Bearer ${AuthService.getToken()}`
          : '',
      },
    });

    return new Promise((resolve, reject) => {
      http.get(`/${id}`).then((response) => {
        resolve(response.data);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static getInvoicePdf(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Invoice ID'));
    }

    return this.httpService.getFileDownload(`/${id}/pdf`);
  }

  static postInvoice(request) {
    return new Promise((resolve, reject) => {
      this.httpService.post('/', request).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static deleteInvoice(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Invoice ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.delete(`/${id}`).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static updateInvoice(id, request) {
    if (!id) {
      return Promise.reject(new Error('Missing Invoice ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.patch(`/${id}`, request).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }
}

BillableService.httpService = new HttpService({
  baseURL: `${typeof window !== 'undefined'
    ? env.REACT_APP_HORSE_API
    : ''}/invoices`,
});
